import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "close-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "retry-recording-modal-icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "retry-recording-modal-error-message retry-recording-modal-spacing"
}
const _hoisted_6 = {
  key: 1,
  class: "retry-recording-modal-message"
}

import { RETRY_LIMIT } from '../../assets/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'RetryPopup',
  props: {
  visible: {
    type: Boolean,
    required: true,
  },
  setVisible: {
    type: Function,
    required: true,
  },
  retryCount: {
    type: Number,
    default: 0,
  },
  errorMessage: {
    type: String,
    default: '',
  }
},
  emits: ["retryUpload"],
  setup(__props, { emit: __emit }) {

const CloseGreyIcon = require("../../assets/images/Close-grey.svg") as string;
const ErrorOutline = require("../../assets/images/ErrorOutlineRed.svg") as string;

const props = __props

const emit = __emit

function close() {
  props.setVisible(false);
}

function onClickRetry() {
  emit("retryUpload");
}


return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: props.visible,
    header: "false",
    class: _normalizeClass(["retry-recording-modal", props.retryCount > _unref(RETRY_LIMIT) ? 'retry-recording-modal-new-height' : '']),
    modal: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: close,
          class: "close"
        }, [
          _createElementVNode("img", {
            src: _unref(CloseGreyIcon),
            alt: "Close menu"
          }, null, 8, _hoisted_2)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _unref(ErrorOutline) }, null, 8, _hoisted_4)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "retry-recording-modal-title" }, " Upload failed ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "retry-recording-modal-message" }, " We couldn’t upload your recording. Check your connection and try again. ", -1)),
      (props.retryCount > _unref(RETRY_LIMIT))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.errorMessage), 1))
        : _createCommentVNode("", true),
      (props.retryCount > _unref(RETRY_LIMIT))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString("If you continue to experience issues with uploading, please reach out to our support team for assistance.")))
        : _createCommentVNode("", true),
      _createElementVNode("div", { class: "retry-recording-modal-button-wrapper" }, [
        _createElementVNode("button", {
          onClick: onClickRetry,
          class: "retry-recording-modal-button"
        }, " Retry ")
      ])
    ]),
    _: 1,
    __: [0,1]
  }, 8, ["visible", "class"]))
}
}

})